export default "__VITE_ASSET__Bi7iDn6e__"